/**
 * Floor Plan Card Selected Epic
 *
 * Reacts to floorPlanCardSelected actions and dispatches navigateTo to switch to floor plan
 * detail with the relevant selected lot / context preserved.
 *
 * @param {object} params
 * @param {object} params.dataActions - Actions from the feature data slice instance
 * @param {Observable} params.store$ - Redux store state observable
 * @returns {import('redux-observable').Epic}
 */

import { map, withLatestFrom } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { VIEW_FLOOR_PLAN_DETAIL } from '../constants';
import { selectSelectedLotId } from './selectors';

function createFloorPlanCardSelectedEpic({ dataActions, store$ }) {
  return (action$) => action$.pipe(
    ofType(dataActions.floorPlanCardSelected.type),
    withLatestFrom(store$),
    map(([action, state]) => {
      const selectedLotId = selectSelectedLotId(state) ?? null;

      const planId = Number(action.payload);
      return dataActions.navigateTo({
        view: VIEW_FLOOR_PLAN_DETAIL,
        context: {
          planId: Number.isFinite(planId) ? planId : null,
          selectedLotId,
          housingUnitId: null,
        },
      });
    }),
  );
}

export default createFloorPlanCardSelectedEpic;
